import PlacementLengthJSON from 'app/assets/jsons/PlacementLength.json';

export function GetPlacementLengths() {
  const data = PlacementLengthJSON.placementLengths;
  return data;
}
